import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AuditLogPage() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit-logs").then(({ data }) => setLogs(data));
  }, []);

  return (
    <div className="p-8 space-y-6" data-testid="audit-log-page">
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-cyan">Governance</span>
        <h1 className="text-3xl font-bold uppercase tracking-tight mt-1 text-brand-navy">Audit Trail</h1>
      </div>
      <div className="border border-slate-200 bg-white">
        {logs.map((l) => (
          <div key={l.id} data-testid={`audit-entry-${l.id}`} className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 p-4 border-b border-slate-100 text-sm">
            <div>
              <p className="font-bold uppercase tracking-wide text-xs text-brand-cyan">{l.action}</p>
              <p className="text-slate-500 mt-1">{l.details}</p>
            </div>
            <div className="sm:text-right text-slate-400 text-xs">
              <p>{l.actor_name}</p>
              <p>{new Date(l.created_at).toLocaleString()}</p>
            </div>
          </div>
        ))}
        {!logs.length && <p className="p-6 text-center text-slate-400">No audit entries yet</p>}
      </div>
    </div>
  );
}
